import { http } from '../plugins/api';

const base = 'content';

export const getBanner = () => {
  const url = `/${base}/pages/1?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerProfile = () => {
  const url = `/${base}/pages/2?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerProdukPembiayaan = () => {
  const url = `/${base}/pages/3?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerSimulasiCicilan = () => {
  const url = `/${base}/pages/4?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMitraMaxi = () => {
  const url = `/${base}/pages/5?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerAxi = () => {
  const url = `/${base}/pages/6?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerGudangInfo = () => {
  const url = `/${base}/pages/7?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerKebijakanPrivacy = () => {
  const url = `/${base}/pages/8?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiTravel = () => {
  const url = `/${base}/pages/9?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiEdukasi = () => {
  const url = `/${base}/pages/10?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiUsaha = () => {
  const url = `/${base}/pages/11?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiSehat = () => {
  const url = `/${base}/pages/12?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiGriya = () => {
  const url = `/${base}/pages/13?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMaxiExtraguna = () => {
  const url = `/${base}/pages/14?include=images`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerDanaTunaiLandscape = () => {
  const url = `/${base}/banners/1`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerDanaTunaiPortrait = () => {
  const url = `/${base}/banners/3`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMitraBisnisLandscape = () => {
  const url = `/${base}/banners/2`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getBannerMitraBisnisPortrait = () => {
  const url = `/${base}/banners/4`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
}

export const getTestimonies = () => {
  const url = `/${base}/testimonials?filter[status_id]=28`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getArticles = ({ size = 15, page = 1 , useby = '' , statusId = 22 }) => {
  const url = `/${base}/news`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };
  const params = {
    ['filter[useby]']: useby,
    ['filter[status_id]']: statusId,
    ['page[number]']: page,
    ['page[size]']: size,
    ['sort']: '-created-at',
  }

  return http.get(url, {
    headers,
    params
  });
};

export const getArticlesPopular = ({ size = 15, page = 1 }) => {
  const url = `/${base}/news?sort=-view`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };
  const params = {
    ['page[number]']: page,
    ['page[size]']: size,
    ['sort']: '-created-at'
  }

  return http.get(url, {
    headers,
    params
  });
};

export const getArticleById = (id) => {
  const url = `/${base}/news/${id}`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getArticleBySlug = (slug) => {
  const url = `/${base}/news/slug/${slug}`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getCategoryById = (id) => {
  const url = `/${base}/categories/${id}`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers,
  });
};

export const getMateri = (page) => {
  const url = `/${base}/downloads?page[number]=${page}&sort=-created-at`;
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers
  });
};

export const createTestimoni = (payload) => {
  const url = `/${base}/testimonials`;

  let formData = new FormData()

  Object.keys(payload).forEach(key => {
    formData.append(key, payload[key])
  })

  return http.post(url, formData)
}
